/* JCI: Warehouse Flickity with the reference's 5.5-second loop and progress line. */
window.JCIHome.register('weekly-deals', (root, on, cleanup) => {
  const track = root.querySelector('.deal-slides');
  const slides = [...track.children];
  const controls = root.querySelector('.deal-controls');
  const count = root.querySelector('.deal-count');
  const progress = root.querySelector('.deal-timer-fill');
  const carousel = root.querySelector('.deal-slider');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const duration = 5500;
  if (!slides.length) return;
  controls.hidden = slides.length < 2;
  let index = 0, slider, timeout, animation;
  let visible = false, hovered = false, focused = false, editing = false;

  function stop() {
    window.clearTimeout(timeout);
    animation?.cancel();
    animation = null;
  }
  function schedule() {
    stop();
    const running = slides.length > 1 && visible && !hovered && !focused && !editing && !document.hidden && !motion.matches;
    carousel.dataset.rotating = String(running);
    if (!running) return;
    animation = progress.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], {
      duration, fill: 'forwards', easing: 'linear'
    });
    timeout = window.setTimeout(() => select(index + 1), duration);
  }
  function update() {
    count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    slides.forEach((slide, i) => {
      slide.setAttribute('aria-label', `${i + 1} of ${slides.length}`);
      slide.inert = i !== index;
    });
    schedule();
  }
  if (window.Flickity && slides.length > 1) {
    slider = new window.Flickity(track, {
      cellSelector: '.deal-slide', contain: true, wrapAround: true,
      prevNextButtons: false, pageDots: false, adaptiveHeight: true,
      accessibility: true, draggable: true
    });
    slider.on('change', value => { index = value; update(); });
    root.querySelectorAll('img').forEach(img => on(img, 'load', () => slider.resize()));
    cleanup(() => slider.destroy());
  }
  function select(value, manual = false) {
    index = (value + slides.length) % slides.length;
    if (slider) slider.select(index, false, true);
    else slides.forEach((slide, i) => { slide.hidden = i !== index; });
    update();
    if (manual) root.querySelector('.deal-announcement').textContent = slides[index].querySelector('h3')?.textContent || '';
  }
  on(root.querySelector('.deal-prev'), 'click', () => select(index - 1, true));
  on(root.querySelector('.deal-next'), 'click', () => select(index + 1, true));
  on(carousel, 'pointerenter', event => { if (event.pointerType !== 'touch') { hovered = true; schedule(); } });
  on(carousel, 'pointerleave', () => { hovered = false; schedule(); });
  on(carousel, 'focusin', event => { focused = event.target.matches(':focus-visible'); schedule(); });
  on(carousel, 'focusout', event => { if (!carousel.contains(event.relatedTarget)) { focused = false; schedule(); } });
  on(document, 'visibilitychange', schedule);
  on(motion, 'change', schedule);
  on(root, 'shopify:block:select', event => {
    editing = true;
    const selected = slides.findIndex(slide => slide.dataset.jciBlock === event.detail.blockId);
    if (selected >= 0) select(selected);
    else schedule();
  });
  on(root, 'shopify:block:deselect', () => { editing = false; schedule(); });
  const observer = new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    schedule();
  }, { threshold: 0.35 });
  observer.observe(carousel);
  cleanup(() => { stop(); observer.disconnect(); });
  track.dataset.jciReady = 'true';
  select(0);
});
